import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: gray;
  background-image: url("/Assets/Images/Bg.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;
